import {
  Component,
  Input,
  OnInit,
  ChangeDetectorRef,
  ChangeDetectionStrategy
} from '@angular/core';
import { takeUntil } from 'rxjs/operators';

import { RenderSlugService } from 'render/services/render-slug.service';
import { RenderStateService } from 'render/services/render-state/render-state.service';
import { UnsubscribeComponent } from 'shared/directives/unsubscribe.component';
import { IdtComponent } from 'shared/models/idt-components/idt-component.models';


@Component({
  selector: 'render-layout-slot[layout][slot]',
  templateUrl: 'render-layout-slot.component.html',
  styleUrls: ['./render-layout-slot.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RenderLayoutSlotComponent extends UnsubscribeComponent implements OnInit {

  @Input() public layout!: IdtComponent;
  @Input() public slot!: string;

  public slices: IdtComponent[] | undefined;

  constructor(
    private readonly renderSlugService: RenderSlugService,
    private readonly renderStateService: RenderStateService,
    private readonly cd: ChangeDetectorRef
  ) {
    super();
  }

  public ngOnInit(): void {
    const slug = this.renderSlugService.getSlug();
    this.renderStateService.getSlotComponents$(slug, this.layout.id, this.slot).pipe(
      takeUntil(this.clearSubscriptions$)
    ).subscribe((slices: IdtComponent[]) => {
      this.slices = slices;
      this.cd.markForCheck();
    });
  }

  public trackBySlice(index: number, item: IdtComponent): string {
    return item.id;
  }

}
